<!--
  全局「联系我们」企业微信二维码弹框。
  在 App.vue 挂载一次，通过 bus("openContactQr") 事件触发显示。
  仅在中文环境下由 useContact 触发（英文走预约链接）。
-->
<script setup lang="ts">
import { ref, onMounted, onUnmounted } from "vue";
import { useI18n } from "vue-i18n";
import MyDialog from "@/components/MyDialog/index.vue";
import bus from "@/utils/bus";
import qr from "@/assets/images/contact_me_qr_zh.png";

const { t } = useI18n();
const show = ref(false);

const open = () => {
  show.value = true;
};

onMounted(() => bus.on("openContactQr", open));
onUnmounted(() => bus.off("openContactQr", open));
</script>

<template>
  <MyDialog
    v-model="show"
    width="22rem"
    :btnObj="{ showFooter: false }"
    :showClose="true"
    :isBlankClose="true"
    customClassName="contact-qr-dialog"
  >
    <template #title>{{ t("common.qrDialogTitle") }}</template>
    <template #content>
      <div class="contact-qr">
        <img class="contact-qr-img" :src="qr" :alt="t('common.qrDialogTitle')" />
        <div class="contact-qr-caption">{{ t("common.qrDialogCaption") }}</div>
        <a class="contact-qr-phone" href="tel:18180509790">
          <span>{{ t("common.businessPhone") }}</span>
          <strong>18180509790</strong>
        </a>
      </div>
    </template>
  </MyDialog>
</template>

<style scoped lang="scss">
:deep(.contact-qr-dialog .dialog-title) {
  text-align: center;
}

.contact-qr {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 4px 0 8px;
}
.contact-qr-img {
  width: 240px;
  height: 240px;
  object-fit: contain;
  border-radius: 12px;
}
.contact-qr-caption {
  color: #6c5c8b;
  font-family: "Inter";
  font-size: 15px;
  line-height: 22px;
  text-align: center;
}
.contact-qr-phone {
  display: inline-flex;
  align-items: baseline;
  gap: 10px;
  color: #6c5c8b;
  font-family: "Inter";
  font-size: 14px;
  line-height: 1.4;
  text-decoration: none;

  strong {
    color: #2e1b53;
    font-size: 17px;
    font-weight: 600;
    letter-spacing: .02em;
  }
}
</style>
